import { getToken } from '../../../helpers/Token';

export const login = (
  state = { userRole: 'admin', loggedInUser: getToken(), loading: false },
  action
) => {
  switch (action.type) {
    case 'LOGIN_WITH_JWT': {
      console.log('LOGIN_WITH_JWT ', state.loading);
      return { ...state, ...action.payload, loading: false };
    }
    case 'LOGOUT_WITH_JWT': {
      console.log('LOGOUT_WITH_JWT ', state.loading);
      return {
        ...state,
        userRole: 'admin',
        loading: false,
        loggedInUser: undefined,
      };
    }

    case 'AUTH_LOADING': {
      console.log('AUTH_LOADING ', state.loading);
      return { ...state, loading: action.payload };
    }

    default: {
      return state;
    }
  }
};
